export type CountryKeys = 'peru' | 'colombia' | 'brasil' | 'neutro'

export const COUNTRY_COLORS: { [key in CountryKeys]: string } = {
  peru: '#38461B',
  colombia: '#EBE070',
  brasil: '#95C11C',
  neutro: '#F1F1ED',
}
